<template>
    <iframe v-if="ready" :src="url"></iframe>
</template>

<script>
    import {mapState} from 'vuex';
    import {services, eventBus} from "../../main"
    export default {
        name: "PostChallengeInteract",
        props: {
            challenge: {type: [Object], default: () => null},
            companyId: {type: String, default: null},
            interactFinishedHandler: {type: [Function], default: {}},
        },
        data() {
            return {
                userProfileRequest: null
            }
        },
        created() {
            if (this.isAuthenticated) {
                this.userProfileRequest = services.userService.getUserProfile();
            }

            eventBus.$on('user-profile-changed', () => {
                this.userProfileRequest = {loaded: false, error: null};
                this.userProfileRequest = services.userService.getUserProfile();
            })
        },
        mounted() {
            window.addEventListener("message", (event) => {
                if (event.origin !== INTERACTS_API_URL) {
                }
                if (event.data === "interact-finished") {
                    this.interactFinishedHandler();
                }
            }, false);
        },
        computed: {
            ready: function() {
                return this.isAuthenticated && this.challenge.id && this.userProfileRequest.loaded && !this.userProfileRequest.error;
            },
            url: function() {
                let getParams = new URLSearchParams({
                    user_token: services.auth.getIDToken(),
                    programming_language:  this.challenge.technology.language,
                    region: this.region,
                    profession: this.profession,
                });

                if (typeof window.INTERACTS_API_URL === "undefined" || window.INTERACTS_API_URL == "") {
                    this.interactFinishedHandler();
                    return
                }

                if (this.companyId) {
                    getParams.append("company_id", this.companyId);
                }
                return `${window.INTERACTS_API_URL}/interacts/${this.challenge.id}/post_challenge_content/?${getParams.toString()}`;
            },
            region: function () {
                if (!this.userProfileRequest.loaded) {
                    return;
                }
                if (this.userProfileRequest.error) {
                    return;
                }

                return this.userProfileRequest.user_profile.encoded_region;
            },
            profession: function () {
                if (!this.userProfileRequest.loaded) {
                    return;
                }
                if (this.userProfileRequest.error) {
                    return;
                }

                return this.userProfileRequest.user_profile.profession;
            },
            ...mapState([
                'isAuthenticated',
            ])
        }
    }
</script>

<style scoped>
    iframe {
        width: 100%;
        height: 700px;
        border: 0;
        overflow: hidden;
    }
</style>
